<!-- Incoterms Management Modal -->
<div class="modal-backdrop fade show" *ngIf="showModal"
     style="z-index: 1055 !important;"
     (click)="close()"></div>

<div class="modal fade show d-block" *ngIf="showModal"
     style="z-index: 1056 !important;"
     tabindex="-1" role="dialog">
  <div class="modal-dialog modal-lg modal-dialog-centered">
    <div class="modal-content">
      <!-- Modal Header -->
      <div class="modal-header">
        <div>
          <h5 class="modal-title mb-1">Incoterms Management</h5>
          <small class="text-muted">Manage international commercial terms</small>
        </div>
        <button type="button" class="btn-close" (click)="close()"></button>
      </div>

      <!-- Modal Body -->
      <div class="modal-body">
        <!-- Search Bar and Add Button -->
        <div class="d-flex justify-content-between align-items-center mb-3">
          <div class="input-group" style="max-width: 300px;">
            <span class="input-group-text">
              <i class="bi bi-search"></i>
            </span>
            <input
              type="text"
              class="form-control"
              placeholder="Search incoterms..."
              [(ngModel)]="searchTerm"
              (input)="filterIncoterms()"
            />
          </div>
          <button class="btn btn-primary" (click)="openAddIncotermModal()">
            <i class="bi bi-plus-circle me-1"></i>Add Incoterm
          </button>
        </div>

        <!-- Incoterms Table -->
        <div class="table-responsive">
          <table class="table table-hover align-middle">
            <thead>
              <tr>
                <th style="width: 15%;">Code</th>
                <th style="width: 70%;">Description</th>
                <th style="width: 15%;" class="text-end">Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let incoterm of filteredIncoterms">
                <td><strong>{{ incoterm.code }}</strong></td>
                <td>{{ incoterm.description }}</td>
                <td class="text-end">
                  <button class="btn btn-sm btn-link p-1" (click)="openEditIncotermModal(incoterm)" title="Edit">
                    <i class="bi bi-pencil"></i>
                  </button>
                  <button class="btn btn-sm btn-link text-danger p-1" (click)="deleteIncoterm(incoterm.id)" title="Delete">
                    <i class="bi bi-trash"></i>
                  </button>
                </td>
              </tr>
              <tr *ngIf="filteredIncoterms.length === 0">
                <td colspan="3" class="text-center text-muted py-4">
                  <i class="bi bi-inbox me-2"></i>No incoterms found
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- Modal Footer -->
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="close()">Close</button>
      </div>
    </div>
  </div>
</div>

<!-- Add Incoterm Modal (Nested) -->
<div class="modal-backdrop fade show" *ngIf="showAddModal"
     style="z-index: 1060 !important; background-color: rgba(0, 0, 0, 0.9) !important;"
     (click)="closeAddIncotermModal()"></div>

<div class="modal fade show d-block" *ngIf="showAddModal"
     style="z-index: 1061 !important;"
     tabindex="-1" role="dialog">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <!-- Add Modal Header -->
      <div class="modal-header">
        <h5 class="modal-title">Add New Incoterm</h5>
        <button type="button" class="btn-close" (click)="closeAddIncotermModal()"></button>
      </div>

      <!-- Add Modal Body -->
      <div class="modal-body">
        <form>
          <!-- Incoterm Code -->
          <div class="mb-3">
            <label for="addIncotermCode" class="form-label">Incoterm Code <span class="text-danger">*</span></label>
            <input
              type="text"
              class="form-control"
              id="addIncotermCode"
              [(ngModel)]="formData.code"
              (input)="onCodeInput()"
              name="code"
              placeholder="e.g., FOB"
              maxlength="10"
              required
            />
            <small class="form-text text-muted">Maximum 10 characters, automatically converted to uppercase</small>
          </div>

          <!-- Description -->
          <div class="mb-3">
            <label for="addIncotermDescription" class="form-label">Description <span class="text-danger">*</span></label>
            <textarea
              class="form-control"
              id="addIncotermDescription"
              [(ngModel)]="formData.description"
              name="description"
              rows="5"
              placeholder="e.g., Free On Board - The seller fulfills their obligation to deliver when the goods have passed over the ship's rail at the named port of shipment."
              required></textarea>
          </div>
        </form>
      </div>

      <!-- Add Modal Footer -->
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="closeAddIncotermModal()">Cancel</button>
        <button type="button" class="btn btn-primary" (click)="createIncoterm()">Create</button>
      </div>
    </div>
  </div>
</div>

<!-- Edit Incoterm Modal (Nested) -->
<div class="modal-backdrop fade show" *ngIf="showEditModal"
     style="z-index: 1060 !important; background-color: rgba(0, 0, 0, 0.9) !important;"
     (click)="closeEditIncotermModal()"></div>

<div class="modal fade show d-block" *ngIf="showEditModal"
     style="z-index: 1061 !important;"
     tabindex="-1" role="dialog">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <!-- Edit Modal Header -->
      <div class="modal-header">
        <h5 class="modal-title">Edit Incoterm</h5>
        <button type="button" class="btn-close" (click)="closeEditIncotermModal()"></button>
      </div>

      <!-- Edit Modal Body -->
      <div class="modal-body">
        <form>
          <!-- Incoterm Code -->
          <div class="mb-3">
            <label for="editIncotermCode" class="form-label">Incoterm Code <span class="text-danger">*</span></label>
            <input
              type="text"
              class="form-control"
              id="editIncotermCode"
              [(ngModel)]="editFormData.code"
              (input)="onEditCodeInput()"
              name="editCode"
              maxlength="10"
              required
            />
            <small class="form-text text-muted">Maximum 10 characters, automatically converted to uppercase</small>
          </div>

          <!-- Description -->
          <div class="mb-3">
            <label for="editIncotermDescription" class="form-label">Description <span class="text-danger">*</span></label>
            <textarea
              class="form-control"
              id="editIncotermDescription"
              [(ngModel)]="editFormData.description"
              name="editDescription"
              rows="5"
              required></textarea>
          </div>
        </form>
      </div>

      <!-- Edit Modal Footer -->
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="closeEditIncotermModal()">Cancel</button>
        <button type="button" class="btn btn-primary" (click)="updateIncoterm()">Update</button>
      </div>
    </div>
  </div>
</div>
